export default __webpack_public_path__ + "static/Avenir-Book-01-505930b7d196f63a76d362020c469c7e.ttf";